import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Bot } from 'lucide-react';

export const Route = createFileRoute('/admin-console/ai')({
    staticData: {
        permissions: ['admin_ai:read'],
        breadcrumb: {
            title: 'AI',
            inactive: true,
        },
        ui: {
            icon: Bot,
            title: 'AI',
            menuDescription: 'Manage AI configuration',
        },
    },
    component: Outlet,
});
